/**
 * @generated SignedSource<<358bdf0336e05d6958a8d4c48534d065>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type connectShopDialogQuery$variables = {
  id: string;
};
export type connectShopDialogQuery$data = {
  readonly zendeskArticle: {
    readonly body: string | null;
    readonly title: string | null;
  } | null;
};
export type connectShopDialogQuery = {
  response: connectShopDialogQuery$data;
  variables: connectShopDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "connectShopDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ZendeskArticle",
        "kind": "LinkedField",
        "name": "zendeskArticle",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "connectShopDialogQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ZendeskArticle",
        "kind": "LinkedField",
        "name": "zendeskArticle",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b6f892882b502de104ca5cb3257511e2",
    "id": null,
    "metadata": {},
    "name": "connectShopDialogQuery",
    "operationKind": "query",
    "text": "query connectShopDialogQuery(\n  $id: ID!\n) {\n  zendeskArticle(id: $id) {\n    title\n    body\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5e11bfb2b7485294d40726408c0dfd96";

export default node;
